import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import { goAsync } from "@bd-utils/goAsync";
import $ from "jquery";

export const WelcomePage = () => {
  const isWelcomePage = $("body").hasClass("welcome-page");
  if (!isWelcomePage) return false;

  $("#pageWrapper").addClass("is-loaded");

  const elms = {
    btnSetupProfile: ".js-setup-profile",
    avatarUpload: ".js-avatar-upload",
    inputAvatar: ".js-avatar",
    inputNickname: ".js-nickname",
    submit: ".js-submit-avatar",
    startGameBtn: ".js-start-game",
    startDialogueGame: ".js-start-dialogue",
    btnSnackBarClose: ".js-close-snackbar",
    loginBtn: ".js-submit-login",
    inputCode: ".js-input-code",
    inputEmail: ".js-input-email",
    codeWrapper: ".loginScreen__form",
    consentCheckbox: ".js-consent-checkbox",
  };

  /* Nuclear Quickscan Consent Validation */

  const isNuclearQuickscan = CONFIG.siteSetup === "nuclear-quickscan";
  const $consentCheckbox = $(elms.consentCheckbox);
  const $loginBtn = $(elms.loginBtn);

  if (isNuclearQuickscan) {
    // Initially disable the button
    $loginBtn.prop("disabled", true);

    // Handle consent checkbox change
    $consentCheckbox.on("change", function () {
      const isChecked = $(this).is(":checked");
      $loginBtn.prop("disabled", !isChecked);
    });
  }

  /* Reading/Closing Instructions */

  const $instructionsBtn = $(".js-read-instructions");
  const $instructions = $(".js-instructions");
  const $closeInstructions = $(".js-close-instructions");
  const $snackbar = $(".snackbar");

  $instructionsBtn.on("click", (e) => {
    const $el = $(e.currentTarget);
    const phase = $el.attr("data-phase");
    $instructions.removeClass("is-open");
    $instructions.filter(`[data-phase="${phase}"]`).addClass("is-open");
  });

  $closeInstructions.on("click", () => {
    $instructions.removeClass("is-open");
  });

  /* Switching Between Games/Phases */

  const $phaseBtn = $(".js-phase-button");
  const $phaseContent = $(".js-phase-content");

  $phaseBtn.each(function (i) {
    $(this).on("click", function () {
      $(this).addClass("is-selected");
      $phaseBtn.not(this).removeClass("is-selected");

      if (i == 0) $phaseContent.removeClass("is-shifted");
      else $phaseContent.addClass("is-shifted");
    });
  });

  /**
   * @param {JQuery.ClickEvent} e
   */
  const goToDialogueGame = (e) => {
    const $el = $(e.currentTarget);
    const location = $el.attr("data-location");

    if (!location) return;

    bdjs.showLoading(function () {
      window.location.href = location;
    });
  };
  $(elms.startDialogueGame).on("click", goToDialogueGame);

  // blindspot
  if (CONFIG.GP && window.location.search.includes("bd-token")) {
    window.location.href = window.location.href.replace("/welcome", "");
  }

  /**
   * @this {HTMLElement}
   * @param {JQuery.ClickEvent} e
   */
  const goToNextScreen = function (e) {
    const goToSetupProfile = function () {
      e.preventDefault();

      bdjs.showLoading(function () {
        $(".gameScreen")
          .removeClass("is-active")
          .filter("#setupScreen")
          .addClass("is-active");

        setTimeout(() => {
          bdjs.hideLoading();
        }, 300);
      });
    };

    const goToStartGame = function () {
      bdjs.showLoading(() => {
        const currentUserId = Number(CONFIG.user?.id || 0);
        const authenticate = currentUserId
          ? Promise.resolve()
          : bdapi.post("public/create-guest-user");

        authenticate
          .then(() => bdapi.post("member/start-game-without-setup-profile"))
          .then((response) => {
            // const status = response.status;
            const data = response.data.data;

            if (data.redirect) {
              //window.location.href = data.redirect;
              bdjs.redirect(data.redirect, response.request.responseURL);
              return false;
            }
          })
          .catch((error) => {
            console.error(error);
            bdjs.hideLoading();
          });
      });
    };

    $(this).addClass("is-loading");
    const usingAvatarSetup = $(this).attr("data-using-avatar-setup") == "1";
    if (usingAvatarSetup) {
      goToSetupProfile();
    } else {
      goToStartGame();
    }
  };

  $(elms.btnSetupProfile).on("click", goToNextScreen);

  /* SETUP AVATAR */
  const $displayEl = $(`.display-img`);

  if ($displayEl.attr("src") === "") {
    $displayEl.hide();
  }

  /**
   * @param {HTMLInputElement} input
   */
  function readURL(input) {
    if (input.files && input.files[0]) {
      var reader = new FileReader();
      reader.onload = function (e) {
        if (!e.target) return;
        $displayEl.attr("src", String(e.target.result));
      };
      reader.readAsDataURL(input.files[0]);
    }
  }

  $(elms.inputAvatar)
    .on("change", function () {
      const $selectedAvatar = $(`${elms.inputAvatar}:checked`);
      const urlImg = $selectedAvatar.siblings("#avatarIcon").attr("src") ?? "";

      const $avatars = $(elms.inputAvatar);
      $avatars.parent().removeClass("is-checked");

      $selectedAvatar.parent().addClass("is-checked");

      $displayEl.attr("src", urlImg);
      $displayEl.show();

      $(elms.avatarUpload).val("");
    })
    .trigger("change");

  $(elms.inputNickname).on("input", function () {
    const name = $(this).val();
    if (name) {
      $(elms.submit).prop("disabled", false);
      $(".setupScreen__name").addClass("not-empty");
    } else {
      $(elms.submit).prop("disabled", true);
      $(".setupScreen__name").removeClass("not-empty");
    }
  });

  $(elms.avatarUpload).on(
    "change",
    /** @this {HTMLInputElement} */
    function () {
      const $this = $(this);
      const $avatars = $(elms.inputAvatar);
      $avatars.prop("checked", false);
      $avatars.parent().removeClass("is-checked");

      if ($this?.[0]?.files?.[0]) {
        $displayEl.show();
        readURL(this);
      } else {
        $avatars.first().prop("checked", true).trigger("change");
      }
    },
  );

  $(elms.submit).on("click", function (e) {
    e.preventDefault();
    const $this = $(this);

    const formData = new FormData();

    //nickname
    formData.append("nickname", String($(elms.inputNickname).val()));

    //stock avatar
    const avatar = $(elms.inputAvatar.concat(":checked")).val();
    formData.append("avatar", String(avatar ? avatar : 0));

    //custom upload avatar
    /**
     * @type {JQuery<HTMLInputElement>}
     */
    const $customAvatar = $(elms.avatarUpload);
    var uploadMode = false;
    if ($customAvatar?.[0]?.files?.[0]) {
      uploadMode = true;
      formData.append("custom_avatar", $customAvatar[0].files[0]);
    }

    $this.prop("disabled", true);

    if (uploadMode) {
      $(".uploadBar").addClass("is-uploading");
    }

    bdapi
      .post("member/submit-profile", formData, {
        onUploadProgress: function (e) {
          const percentUploaded = Math.round((e.loaded * 100) / e.total);

          $(".uploadBar__progressbar").css("width", percentUploaded + "%");

          $(".uploadPercent").html(String(percentUploaded));

          if (percentUploaded == 100) {
            $(".uploadBar").removeClass("is-uploading");
            bdjs.showLoading();
          }
        },
      })
      .then((response) => {
        if (
          response.status !== 200 ||
          !response.data ||
          typeof response.data !== "object"
        ) {
          $this.removeAttr("disabled");
          bdjs.hideLoading();
          return alert("Avatar upload error, please contact admin");
        }

        if (!response.data.success) {
          $this.removeAttr("disabled");
          bdjs.hideLoading();
          return alert(response.data.data.msg);
        }
        const data = response.data.data;

        if (data.redirect) {
          bdjs.redirect(data.redirect, response.request.responseURL);
          return false;
        }

        $this.removeAttr("disabled");
      })
      .catch((error) => {
        console.error(error);
        $this.removeAttr("disabled");
        bdjs.hideLoading();
        alert("Avatar upload error, please contact admin");
      });
  });

  const loginAsGuest = async function () {
    const $btnSubmit = $(elms.loginBtn);

    const captcha =
      CONFIG.siteSetup !== "nuclear-quickscan" &&
      typeof window.grecaptcha !== "undefined"
        ? window.grecaptcha
        : null; // eslint-disable-line no-undef

    $btnSubmit.addClass("is-loading");
    $snackbar.removeClass("is-active");

    const request = bdapi.post;
    const { data: response, err } = await goAsync(
      request("public/login", {
        lang: getLang(),
        re_response: captcha?.getResponse(),
      }),
    );

    $snackbar.removeClass("is-error");
    $btnSubmit.removeClass("is-loading");

    captcha?.reset();

    const restData = response?.data || {};
    const restMessage =
      restData?.data?.message || "Something went wrong. Please try again!";

    if (err || !restData?.success) $snackbar.addClass("is-error");

    $snackbar.find(".snackbar__main__text").html(restMessage);
    $snackbar.addClass("is-active");

    if (restData.data.redirect) {
      setTimeout(() => {
        bdjs.redirect(restData.data.redirect, response.request.responseURL);
        return false;
      }, 800);
    }
  };

  const loginUsingCode = async () => {
    const $loginBtn = $(elms.loginBtn);
    const $inputCode = $(elms.inputCode);
    const $codeWrapper = $(elms.codeWrapper);
    const isUsingCaptcha = $(".loginScreen__captcha").length > 0;
    let captcha;

    if ($loginBtn.hasClass("is-loading")) return;

    if (isUsingCaptcha) {
      captcha =
        typeof window.grecaptcha !== "undefined" ? window.grecaptcha : null; // eslint-disable-line no-undef
    }

    $loginBtn.addClass("is-loading");
    const request = bdapi.post;
    const { data: response, err } = await goAsync(
      request("public/login", {
        code: $inputCode.val(),
        lang: getLang(),
        re_response: captcha?.getResponse(),
      }),
    );

    $snackbar.removeClass("is-error");

    captcha?.reset();

    const restData = response?.data || {};
    const restMessage =
      restData?.data?.message || "Something went wrong. Please try again!";
    const isCodeInvalid = restData?.data?.invalidCode || false;

    if (isCodeInvalid) $codeWrapper.addClass("is-error");

    $loginBtn.removeClass("is-loading");
    if (err || !restData?.success) {
      $snackbar.addClass("is-error");
      $snackbar.find(".snackbar__main__text").html(restMessage);
      $snackbar.addClass("is-active");
      return;
    }

    // bdjs.showLoading(() => {
    const redirect = restData?.data?.redirect || window.location.origin;
    window.location.href = redirect + bdjs.suffixURL();
    // }, true);
  };

  const loginUsingMagicLink = async () => {
    const $btnSubmit = $(elms.submit);
    const $inputEmail = $(elms.inputEmail);

    if ($btnSubmit.hasClass("is-loading")) return;

    const captcha =
      typeof window.grecaptcha !== "undefined" ? window.grecaptcha : null; // eslint-disable-line no-undef

    $btnSubmit.addClass("is-loading");
    $snackbar.removeClass("is-active");

    const request = bdapi.post;
    const { data: response, err } = await goAsync(
      request("public/request-magic-link", {
        email: $inputEmail.val(),
        lang: getLang(),
        re_response: captcha?.getResponse(),
      }),
    );

    $snackbar.removeClass("is-error");
    $btnSubmit.removeClass("is-loading");

    captcha?.reset();

    const restData = response?.data || {};
    const restMessage =
      restData?.data?.message || "Something went wrong. Please try again!";

    if (err || !restData?.success) $snackbar.addClass("is-error");

    $snackbar.find(".snackbar__main__text").html(restMessage);
    $snackbar.addClass("is-active");
  };

  /**
   * @this {HTMLElement}
   * @param {JQuery.ClickEvent} e
   */
  const goToLogin = function (e) {
    e.preventDefault();

    // Check consent for nuclear-quickscan
    if (isNuclearQuickscan && !$consentCheckbox.is(":checked")) {
      return false;
    }

    const loginMode = $(this).attr("data-login-mode");
    let loginUrl = window.location.origin + "/wp-login.php";

    switch (loginMode) {
      case "":
      case "none":
        loginAsGuest();
        break;

      case "code":
        loginUsingCode();
        break;

      case "sso":
        if (loginUrl.indexOf("?") != -1) {
          loginUrl = loginUrl + "&option=saml_user_login";
        } else {
          loginUrl = loginUrl + "?option=saml_user_login";
        }

        bdjs.redirect(loginUrl);
        break;

      case "magic_link":
        loginUsingMagicLink();
        break;

      default:
        // TODO implement custom login mode mode
        bdjs.redirect(loginUrl);
        break;
    }
  };

  const getLang = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    // @ts-ignore
    const params = Object.fromEntries(urlSearchParams.entries());
    return params.lang;
  };

  const goStartGameDirectly = () => {
    const isLoggedIn = CONFIG.user;
    let siteUrl = window.location.origin;

    if (isLoggedIn) {
      bdjs.redirect(siteUrl);
    }
  };

  /* Submit avatar on press enter */

  const $submitAvatar = $(elms.submit);

  $(document).on("keypress", function (e) {
    if (e.keyCode == 13 && !$submitAvatar.is(":disabled")) {
      $submitAvatar.trigger("click");
    }
  });

  const closeSnackbar = () => $snackbar.removeClass("is-active");

  $(elms.btnSnackBarClose).on("click", closeSnackbar);
  $(elms.loginBtn).on("click", goToLogin);
  $(elms.startGameBtn).on("click", goStartGameDirectly);

  bdjs.hideLoading();
};
